import { render } from "./SectionShiftingSchedule.vue?vue&type=template&id=2b4811e3&scoped=true"
import script from "./SectionShiftingSchedule.vue?vue&type=script&lang=js"
export * from "./SectionShiftingSchedule.vue?vue&type=script&lang=js"

import "./SectionShiftingSchedule.vue?vue&type=style&index=0&id=2b4811e3&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4811e3"]])

export default __exports__